import { Terminal } from "./terminal";

export class VTerminal extends Terminal {
    portalName: string;
    terminalTypeName: string;
    deviceModelName: string;
    terminalStatusName: string;
    customerName: string;
    customerCode: string;
    customerTerminalMainId: number;
    customerId: number;
    organizationName: string;
    projectName: string;
}
